import request from "../../untils/request.js"


export const getChargeList = (params) => {
    return request.get('/outpatient/feelist/page',{params} )
}

export const getChargeDetail = (id) => {
    return request.get(`/outpatient/feelist/${id}`)
}

export const portionRefundByDetail = (data) => {
    return request.post('/outpatient/feelist/refund',data)
}


export const fullRefund = (params) => {
    return request.get('/outpatient/feelist/refundAll',{params})
}

export const getDrxMainRefundList = (params) => {
    return request.get('/outpatient/feelist/getDrxMainRefundList',{params})
}

export const getDtcmRxMainRefundList = (params) => {
    return request.get('/outpatient/feelist/getDtcmRxMainRefundList',{params})
}

export const getDoctordisposeList = (params) => {
    return request.get('/outpatient/doctordispose/list',{params})
}

export const getDoctordisposePage= (params) => {
    return request.get('/outpatient/doctordispose/page',{params})
}

export const getDoctordisposeOneById = (id) => {
    return request.get(`/outpatient/doctordispose/${id}`)
}

export const refundDoctordispose = (params) => {
    return request.get('/outpatient/doctordispose/applyRefund',{params})
}

export const westRefundRelevance = (data) => {
    return request.post('/outpatient/feelist/refundList',data)
}


export const feeListStatics = (params) => {
    return request.get('/outpatient/feelist/statics',{params})
}


export default{

}